import styled from 'styled-components';

export const AuthorImage = styled.img`
  height: ${({ theme }) => theme.x4spacePx}px;
  width: ${({ theme }) => theme.x4spacePx}px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.color.white};
  vertical-align: middle;
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.color.white};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
